import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

/* istanbul ignore */
@Injectable({
  providedIn: 'root'
})
export class EwbConfigService{


  constructor(
    private readonly store: Store,
    private readonly router: Router
  ) {}

  public canActivate() {
    let ewbMode = this.store.selectSnapshot(state => state.configurations.ewb.mode);
    if(ewbMode === null){
      this.router.navigateByUrl('/home');
      return false;
    }

    return true;
  }
}
